export const isWord = (value) => {
  if (!value || /^[A-Z\s]+$/i.test(value)) {
    return undefined;
  }

  return 'Please enter only letters';
};

export default isWord;
